
/* IMPORT */

import parse from './parse';
import stringify from './stringify';
import traverse from './traverse';

/* MAIN */

const Parser = { parse, stringify, traverse };

/* EXPORT */

export default Parser;
